<template>
  <div style="width: 100%; height: 100%">
    <v-card
      class="custom-card agitator-card"
      style="height: inherit"
    >
      <v-card-title
        class="d-flex flex-column align-start pt-2 pb-2"
        :style="{ backgroundColor: !isLaboratory() && failureAlarmValue ? `red` : `#e3eef9` }"
      >
        <div class="table-title">{{ input.settings.component_name }}</div>
      </v-card-title>

      <v-card-text
        class="mt-3"
        style="position: relative"
      >
        <v-row
          v-if="!isLaboratory()"
          style="margin-bottom: 40px"
        >
          <v-col cols="8">
            <MoveableComponent
              v-if="input.customized.run_order_configuration"
              :item="input.customized.run_order_configuration"
            >
              <component
                :is="input.customized.run_order_configuration.settings.component_type"
                :input="input.customized.run_order_configuration"
              >
              </component>
            </MoveableComponent>
            <MoveableComponent
              v-if="input.customized.discontinuous_order_configuration"
              :item="input.customized.discontinuous_order_configuration"
            >
              <component
                :is="input.customized.discontinuous_order_configuration.settings.component_type"
                :input="input.customized.discontinuous_order_configuration"
              >
              </component>
            </MoveableComponent>
            <MoveableComponent
              v-if="input.customized.stop_order_configuration"
              :item="input.customized.stop_order_configuration"
            >
              <component
                :is="input.customized.stop_order_configuration.settings.component_type"
                :input="input.customized.stop_order_configuration"
              >
              </component>
            </MoveableComponent>
            <MoveableComponent
              v-if="input.customized.continuous_order_configuration"
              :item="input.customized.continuous_order_configuration"
            >
              <component
                :is="input.customized.continuous_order_configuration.settings.component_type"
                :input="input.customized.continuous_order_configuration"
              >
              </component>
            </MoveableComponent>
          </v-col>
          <v-col
            cols="4"
            class="mt-3"
          >
            <div class="centered-div">
              <v-icon
                class="mt-0"
                medium
                :color="engineValue ? `green` : `#7e827f`"
                dark
              >
                mdi-circle
              </v-icon>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="6"
            @click="showVolumeHistoryDialog = true"
          >
            <div
              class="v-label mt-4 body-2"
              style="text-align: center"
            >
              Vol: {{ volumeValue > 1000 ? Math.round(volumeValue) : (volumeValue || 0).toFixed(2) }} L
            </div>
          </v-col>
          <v-col
            cols="6"
            @click="showTemperatureHistoryDialog = true"
          >
            <div
              class="v-label mt-4 mb-4 body-2"
              style="text-align: center"
            >
              Tmp: {{ temperatureValue > 1000 ? Math.round(temperatureValue) : (temperatureValue || 0).toFixed(2) }} ºC
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="!isLaboratory()">
        <v-spacer></v-spacer>
        <v-btn
          v-if="input.customized.variator_speed_configuration?.customized"
          icon
          @click="showVariatorSpeedDialog = true"
        >
          <v-icon>mdi-car-speed-limiter</v-icon>
        </v-btn>
        <v-btn
          v-if="!isProduction()"
          icon
          @click="showTimeConfigurationDialog = true"
        >
          <v-icon>mdi-timer-cog-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="!isProduction()"
          icon
          @click="showVolumeCalibrationDialog = true"
        >
          <v-icon>mdi-arrow-expand-vertical</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
      v-model="showVariatorSpeedDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">Configurar velocidad del variador de {{ input.settings.component_name }}</div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col v-if="input.customized.variator_speed_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.variator_speed_configuration">
                  <component
                    :is="input.customized.variator_speed_configuration.settings.component_type"
                    :input="input.customized.variator_speed_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showVariatorSpeedDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showTimeConfigurationDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">
            Configurar tiempos de funcionamiento discontinuo de {{ input.settings.component_name }}
          </div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col v-if="input.customized.running_time_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.running_time_configuration">
                  <component
                    :is="input.customized.running_time_configuration.settings.component_type"
                    :input="input.customized.running_time_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
            <v-col v-if="input.customized.stopped_time_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.stopped_time_configuration">
                  <component
                    :is="input.customized.stopped_time_configuration.settings.component_type"
                    :input="input.customized.stopped_time_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showTimeConfigurationDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showVolumeCalibrationDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">Calibrar volumen de {{ input.settings.component_name }}</div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <div class="label-write">
                <p class="label-write-text">Volumen tara: 0</p>
              </div>
            </v-col>
            <v-col>
              <v-switch
                inset
                dense
                hide-details
                class="pt-4 mt-1"
                label="Tara"
                v-model="volumeTareOrder"
              ></v-switch>
            </v-col>

            <v-col>
              <div class="v-label pt-4 mt-2">Resultado: {{ volumeTareResult ? "CORRECTO" : "PENDIENTE" }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="input.customized.volume_calibration_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.volume_calibration_configuration">
                  <component
                    :is="input.customized.volume_calibration_configuration.settings.component_type"
                    :input="input.customized.volume_calibration_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
            <v-col>
              <v-switch
                inset
                dense
                hide-details
                class="pt-4 mt-1"
                label="Calibración"
                v-model="volumeCalibrationOrder"
              ></v-switch>
            </v-col>

            <v-col>
              <div class="v-label pt-4 mt-2">Resultado: {{ volumeCalibrationResult ? "CORRECTO" : "PENDIENTE" }}</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showVolumeCalibrationDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="volumeVariable?.seconds > 0"
      v-model="showVolumeHistoryDialog"
    >
      <template>
        <v-container fluid>
          <MultiVariableLineChart
            :title="`Evolución en tiempo real del volumen del ${input.settings.component_name}`"
            realTime
            :address="volumeVariable.formatted_address"
            @close="showVolumeHistoryDialog = false"
          ></MultiVariableLineChart>
        </v-container>
      </template>
    </v-dialog>

    <v-dialog
      v-if="temperatureVariable?.seconds > 0"
      v-model="showTemperatureHistoryDialog"
    >
      <template>
        <v-container fluid>
          <MultiVariableLineChart
            :title="`Evolución en tiempo real de la temperatura del ${input.settings.component_name}`"
            realTime
            :address="temperatureVariable.formatted_address"
            @close="showTemperatureHistoryDialog = false"
          ></MultiVariableLineChart>
        </v-container>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import MoveableComponent from "@/components/generic/MoveableComponent.vue";
import MultiVariableLineChart from "@/components/utils/MultiVariableLineChart.vue";

export default {
  name: "QLVNAgitator",
  props: {
    input: Object,
  },

  components: {
    MoveableComponent,
    MultiVariableLineChart,
  },

  data() {
    return {
      showVariatorSpeedDialog: false,
      showTimeConfigurationDialog: false,
      showVolumeCalibrationDialog: false,
      showVolumeHistoryDialog: false,
      showTemperatureHistoryDialog: false,
    };
  },

  computed: {
    ...mapState(["editing"]),

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type == "koiote-snap7-connection")
        .customized.vartable;
    },

    write_topic() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type == "koiote-snap7-connection")
        .customized.topic_write;
    },

    engineValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_engine)?.value;
    },

    failureAlarmValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_failure_alarm)?.value;
    },

    volumeVariable() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume);
    },

    volumeValue() {
      return this.volumeVariable?.value;
    },

    temperatureVariable() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_temperature);
    },

    temperatureValue() {
      return this.temperatureVariable?.value;
    },

    volumeTareOrder: {
      get() {
        return (
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_order)?.value ==
          true
        );
      },
      set(value) {
        const variableToChange =
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_order) || {};
        variableToChange.value = value;
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: variableToChange?.address,
            value: this.adaptFormat({ type: "BIT", value }),
          },
        });
      },
    },

    volumeTareResult() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_result)
        ?.value;
    },

    volumeCalibrationOrder: {
      get() {
        return (
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_order)
            ?.value == true
        );
      },
      set(value) {
        const variableToChange =
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_order) ||
          {};
        variableToChange.value = value;
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: variableToChange?.address,
            value: this.adaptFormat({ type: "BIT", value }),
          },
        });
      },
    },

    volumeCalibrationResult() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_result)
        ?.value;
    },
  },

  methods: {
    ...mapGetters(["actualPage", "isLaboratory", "isProduction"]),
    ...mapActions("nodered", ["doPublish", "setShowingHistoryAddress"]),

    adaptFormat(item) {
      return (() => {
        switch (item.type) {
          case "BIT":
            return item.value;
          case "ENTERO":
          case "REAL":
            return Number(item.value);
          default:
            return "";
        }
      })();
    },

    handleMediaChange() {
      const DEFAULT_MIN_COMPONENT_WIDTH = 350;
      const DEFAULT_MIN_COMPONENT_HEIGHT = 170;
      const WIDTH_WITHOUT_MARGINS_IN_PERCENTAGE = 96;
      const MARGIN_IN_PIXELS = 15;

      const numberOfColumns = Math.floor(window.innerWidth / DEFAULT_MIN_COMPONENT_WIDTH) || 1;
      const parentDiv = Object.values(this.$parent.$refs).find((r) => r !== undefined);

      if (parentDiv && numberOfColumns === 1) {
        parentDiv.style.paddingBottom = `${MARGIN_IN_PIXELS}px`;
        parentDiv.style.paddingRight = `${MARGIN_IN_PIXELS}px`;
        parentDiv.style.width = `${WIDTH_WITHOUT_MARGINS_IN_PERCENTAGE}%`;
        parentDiv.children[0].children[0].children[1].style.height = `${DEFAULT_MIN_COMPONENT_HEIGHT}px`;
        parentDiv.style.top = `${[...this.$parent.$parent.$refs.ScadaPage.getElementsByClassName("root")]
          .filter((a) => a?.children[0]?.children[0]?.getAttribute("index") !== null)
          .reduce(function (totalTop, previousAgitatorRoot, previousAgitatorRootIndex) {
            return (
              totalTop +
              (previousAgitatorRootIndex < parentDiv.getAttribute("index")
                ? previousAgitatorRoot.children[0].children[0].getBoundingClientRect().height
                : 0)
            );
          }, 0)}px`;
        parentDiv.style.left = `${MARGIN_IN_PIXELS}px`;
      } else if (parentDiv) {
        const agitatorIndex = parentDiv.getAttribute("index");
        const horizontalIndex = agitatorIndex % numberOfColumns;
        parentDiv.style.paddingBottom = `${MARGIN_IN_PIXELS}px`;
        parentDiv.style.paddingRight = `${MARGIN_IN_PIXELS}px`;
        parentDiv.style.width = `${
          WIDTH_WITHOUT_MARGINS_IN_PERCENTAGE / numberOfColumns -
          (numberOfColumns - 1) * (MARGIN_IN_PIXELS / window.innerWidth)
        }%`;
        const agitatorRoots = [...this.$parent.$parent.$refs.ScadaPage.getElementsByClassName("root")].filter(
          (a) => a?.children[0]?.children[0]?.getAttribute("index") !== null
        );

        parentDiv.children[0].children[0].children[1].style.height = `${DEFAULT_MIN_COMPONENT_HEIGHT}px`;

        parentDiv.style.top = `${agitatorRoots.reduce(function (
          totalTop,
          _previousAgitatorRoot,
          previousAgitatorRootIndex
        ) {
          return (
            totalTop +
            (agitatorIndex >= numberOfColumns &&
            (previousAgitatorRootIndex + 1) % numberOfColumns == 0 &&
            previousAgitatorRootIndex < parentDiv.getAttribute("index")
              ? Math.max(
                  ...agitatorRoots
                    .slice(previousAgitatorRootIndex - numberOfColumns + 1, previousAgitatorRootIndex + 1)
                    .map((a) => a.children[0].children[0].getBoundingClientRect().height)
                )
              : 0)
          );
        },
        0)}px`;
        parentDiv.style.left = `${
          (WIDTH_WITHOUT_MARGINS_IN_PERCENTAGE / numberOfColumns) * horizontalIndex +
          ((MARGIN_IN_PIXELS / window.innerWidth) * horizontalIndex + 1)
        }%`;
      }
    },
  },

  watch: {
    showTemperatureHistoryDialog(value) {
      this.setShowingHistoryAddress(value ? this.temperatureVariable.formatted_address : "");
    },

    showVolumeHistoryDialog(value) {
      this.setShowingHistoryAddress(value ? this.volumeVariable.formatted_address : "");
    },
  },

  mounted() {
    if (!this.editing) {
      window.addEventListener("resize", this.handleMediaChange);
      this.$nextTick(() => {
        [...this.$parent.$parent.$refs.ScadaPage.getElementsByClassName("root")].forEach((a) => {
          if (a.children[0].children[0].getAttribute("index") !== null)
            a.children[0].children[0].style.height = "fit-content";
        });
        window.dispatchEvent(new Event("resize"));
      });
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleMediaChange);
  },
};
</script>

<style scoped>
.v-label {
  font-size: 14px;
}

.agitator-card {
  color: rgb(61, 59, 59);
  border: solid;
  border-width: 1px;
}

.centered-div {
  display: flex;
  flex-direction: row;
}

.label-write {
  width: 26%;
  height: 12%;
  left: 4%;
  top: 32%;
  position: absolute;
}

.label-write-text {
  padding: 0;
  margin: 0;
  font-size: medium;
  font-weight: normal;
  text-align: center;
}
</style>
